import React from "react";

import LandingLayout from "@components/layouts/LandingLayout/LandingLayout";

import Intro from "./sections/Intro/Intro";
import FinderPromo from "./sections/FinderPromo/FinderPromo ";
import Tools from "./sections/Tools/Tools";
import FinderDemo from "./sections/FinderDemo/FinderDemo";

import "./Landing.scss";

const Landing = () => {
  return (
    <div className="landing-page">
      <Intro />

      <LandingLayout>
        <FinderPromo />
        <Tools />
        <FinderDemo />
      </LandingLayout>
    </div>
  );
};

export default (
  <>
    <Landing />
  </>
);
